export default __webpack_public_path__ + "static/media/united-kingdom.87bbd402.svg";